import React, { useState } from 'react';
import PatientHistoryModal from './patient-history-modal';

const PatientHistoryButton = ({ patientId, doctorId, disabled = false }) => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    if (!patientId) {
      alert('Please select a patient first');
      return;
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-light btn-sm"
        onClick={handleOpenModal}
        disabled={disabled || !patientId}
        title={!patientId ? "Please select a patient first" : "View/Edit Patient History"}
        style={{ fontSize: '0.875rem' }}
      >
        <i className="fas fa-history me-1"></i>
        Add/View History
      </button>

      {showModal && (
        <PatientHistoryModal
          patientId={patientId}
          doctorId={doctorId}
          show={showModal}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default PatientHistoryButton;